import { z } from 'zod';

/**
 * Bearbeitungssperre gegen zeitgleiches Bearbeiten (§18-Analog): Beleg-Editoren
 * (Verkauf/Einkauf) und das Artikelformular fordern beim Öffnen eine Sperre an
 * und halten sie per Heartbeat, solange der Datensatz noch editierbar (Entwurf)
 * ist. Erweiterbar um weitere Entitäten (Projekt, Kommissionierung, …).
 */
export const lockableEntityTypeSchema = z.enum(['SALES_DOCUMENT', 'PURCHASE_ORDER', 'ARTICLE']);
export type LockableEntityType = z.infer<typeof lockableEntityTypeSchema>;

export const acquireLockSchema = z.object({
  entityType: lockableEntityTypeSchema,
  entityId: z.string().uuid(),
});
export type AcquireLockInput = z.infer<typeof acquireLockSchema>;

export const recordLockHolderSchema = z.object({
  userId: z.string().uuid(),
  name: z.string(),
  acquiredAt: z.string().datetime(),
});
export type RecordLockHolder = z.infer<typeof recordLockHolderSchema>;

/** `mine: true` = Sperre gehört mir (frisch erworben oder per Heartbeat verlängert). */
export const recordLockResponseSchema = z.object({
  mine: z.boolean(),
  holder: recordLockHolderSchema.nullable(),
});
export type RecordLockResponse = z.infer<typeof recordLockResponseSchema>;
